/**
 * web
 */
'use strict';
import 'picturefill'
import $ from 'jquery';
window.$ = $;
window.jQuery = $;

import {gsap, Linear} from 'gsap/all'
import nav from './_modules/nav';
import mv3 from './_modules/mv3';
import bg1Chara from './_modules/bg-chara1';
import bg2Chara from './_modules/bg-chara2';
import conTapestry from './_modules/con-tapestry';
import conClearfile from './_modules/con-clearfile';
import meshiBlack from './_modules/meshi-black';
import conMeshi from './_modules/con-meshi';
import sakeGold from './_modules/sake-gold';
import conOsake from './_modules/con-osake';
import conPuromaido from './_modules/con-puromaido';
import sampleImage from './_modules/sample-image';
import snsShare from './_components/snsShare';

// ブラウザ処理
document.addEventListener('DOMContentLoaded', () => {
  new nav();
  new mv3();
  new bg1Chara();
  new bg2Chara();
  new meshiBlack();
  new conTapestry();
  new conClearfile();
  new conMeshi();
  new sakeGold();
  new conOsake();
  new conPuromaido();
  new sampleImage();
  new snsShare();
}, false);

window.addEventListener('load', () => {
  MvPetalJs.xStartPetal();
}, false);

window.addEventListener('unload', () => {}, false);

/*
Number.isNaN = Number.isNaN || function(any) {
  return typeof any === 'number' && isNaN(any);
};

Number.prototype.map = function(in_min, in_max, out_min, out_max) {
  return ((this - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
};
*/

var MvPetalJs = (function () {

  "use strict";
  /*global $,jQuery,TweenMax,Expo,Quad,Bounce,Power3*/

  var targetID = '#c-mv3';
  var st=0;
  var targetAreaWidth=1440;//エリア幅
  var targetAreaHeight=622;//エリア高さ
  var petalScaleBase=1;//花びら基本スケール
  var petalBackNumber=20;//背景花びら枚数
  var petalFrontNumber=6;//前景ぼかし花びら枚数
  var isPetalPlaying=false;//花びら再生中か否か

  (function ($) {
    ///$(document).ready(onTopReady);
    $(window).resize(onResize);
    $(window).scroll(onScroll);
  }(jQuery));

  function onTopReady(){
    //テスト用ボタン設定
    $("#startBtn").on("click",onStartBtnClick);
    $("#stopBtn").on("click",onStopBtnClick);
  }

  /** startボタンクリック */
  function onStartBtnClick(){
    xStartPetal();
  }

  /** stopボタンクリック */
  function onStopBtnClick(){
    xStopPetal();
  }

  /** 花びら落下を開始します */
  function xStartPetal(){

    //再生中であれば実行しない
    if(isPetalPlaying)return;
    isPetalPlaying=true;

    //エリアサイズ初期化
    onResize();

    //背景用花びら生成
    xSetPetalBack();

    //前景用ぼかし花びら生成
    xSetPetalFront();
  }

  /** 花びら落下を終了します */
  function xStopPetal(){

    //停止中であれば実行しない
    if(!isPetalPlaying)return;
    isPetalPlaying=false;

    //アニメーション停止
    for(var i = 0; i < petalBackNumber; i++){
      gsap.killTweensOf($("#mv_petal_"+i));
    }
    for(var i = 0; i < petalFrontNumber; i++){
      gsap.killTweensOf($("#mv_petal_blur_"+i));
    }

    // 花びらタグ撤去
    $("#mvPetalAreaBack").empty();
    $("#mvPetalAreaFront").empty();
  }


  /** 背景用花びらセット */
  function xSetPetalBack(){
    //背景花びら
    for(var i = 0; i < petalBackNumber; i++){
      var rnd=Math.floor(Math.random()*4)+1;
      var tag='<img id="mv_petal_'+i+'" class="petal" src="/touken/assets/img/petal/petal'+rnd+'.png" alt="">'
      $("#mvPetalAreaBack").append(tag);

      //花びら初期位置
      gsap.set("#mv_petal_"+i,{
        "opacity":1,
        x:Math.random()*targetAreaWidth*1.4-targetAreaWidth*0.2,
        y:-targetAreaHeight*Math.random(),
        scale:(Math.random()*0.4+0.6)*petalScaleBase,
        "display":"block"});
      //花びら目標位置
      gsap.to("#mv_petal_"+i,{
        duration:10+Math.random()*14,
        "opacity":1,
        x:Math.random()*targetAreaWidth*1.4-targetAreaWidth*0.2,
        y:targetAreaHeight+50,
        rotationX:600*Math.random(),
        rotationY:10000*Math.random(),
        rotationZ:6000*Math.random(),
        scale:(Math.random()*0.5+0.3)*petalScaleBase,
        delay:0,
        ease:Linear.easeNone,
        onComplete:onFallBack,
        onCompleteParams:[$("#mv_petal_"+i)]});
    }
  }

  /** 背景用花びら落下時 */
  function onFallBack($tgt){
    //花びら初期位置
    gsap.set($tgt,{
      "opacity":1,
      x:Math.random()*targetAreaWidth*1.4-targetAreaWidth*0.2,
      y:-100,
      scale:(Math.random()*0.4+0.6)*petalScaleBase,
      "display":"block"});
    //花びら目標位置
    gsap.to($tgt,{
      duration:10+Math.random()*14,
      "opacity":1,
      x:Math.random()*targetAreaWidth*1.4-targetAreaWidth*0.2,
      y:targetAreaHeight+50,
      rotationX:600*Math.random(),
      rotationY:10000*Math.random(),
      rotationZ:6000*Math.random(),
      scale:(Math.random()*0.5+0.3)*petalScaleBase,
      delay:0,
      ease:Linear.easeNone,
      onComplete:onFallBack,
      onCompleteParams:[$tgt]});
  }

  /** 前景ぼかし用花びらセット */
  function xSetPetalFront(){
    //前景ぼかし花びら
    for(var i = 0; i < petalFrontNumber; i++){
      var rnd=Math.floor(Math.random()*4)+1;
      var tag='<img id="mv_petal_blur_'+i+'" class="petal" src="/touken/assets/img/petal/petal'+rnd+'_blur.png" alt="">'
      $("#mvPetalAreaFront").append(tag);
      //花びら初期位置
      gsap.set("#mv_petal_blur_"+i,{
        "opacity":1,
        x:Math.random()*targetAreaWidth*1.4-targetAreaWidth*0.2,
        y:-targetAreaHeight*Math.random()-100,
        scale:(Math.random()*0.4+0.6)*petalScaleBase,
        "display":"block"});
      //花びら目標位置
      gsap.to("#mv_petal_blur_"+i,{
        duration:10+Math.random()*14,
        "opacity":1,
        x:Math.random()*targetAreaWidth,
        y:targetAreaHeight+50,
        rotationX:60*Math.random(),
        rotationY:1000*Math.random(),
        rotationZ:600*Math.random(),
        scale:(Math.random()*0.5+0.3)*petalScaleBase,
        delay:0,
        ease:Linear.easeNone,
        onComplete:onFallFront,
        onCompleteParams:[$("#mv_petal_blur_"+i)]});
    }
  }

  /** 前景ぼかし花びら落下時 */
  function onFallFront($tgt){
    //花びら初期位置
    gsap.set($tgt,{
      "opacity":1,
      x:Math.random()*targetAreaWidth*1.4-targetAreaWidth*0.2,
      y:-200,
      scale:(Math.random()*0.4+0.6)*petalScaleBase,
      "display":"block"});
    //花びら目標位置
    gsap.to($tgt,{
      duration:10+Math.random()*14,
      "opacity":1,
      x:Math.random()*targetAreaWidth*1.4-targetAreaWidth*0.2,
      y:targetAreaHeight+50,
      rotationX:60*Math.random(),
      rotationY:1000*Math.random(),
      rotationZ:600*Math.random(),
      scale:(Math.random()*0.5+0.3)*petalScaleBase,
      delay:0,
      ease:Linear.easeNone,
      onComplete:onFallFront,
      onCompleteParams:[$tgt]});
  }

  /*** スクロール ***/
  function onScroll() {

    //スクロール位置
    st = $(window).scrollTop();

    //花びら対象エリア
    var targetAreaTop=$(targetID).offset().top;

    //花びら対象エリアが表示されているときは再生 テスト
    if(st+window.innerHeight>targetAreaTop && st-targetAreaHeight<targetAreaTop){
      xStartPetal();
    }else {
      xStopPetal();
    }
  }

  /*** ステージリサイズ ***/
  function onResize() {

    // エリアサイズを取得
    targetAreaWidth = $(targetID).width();
    targetAreaHeight = $(targetID).height();

    // エリアサイズで花びらスケール調整
    petalScaleBase = targetAreaWidth/1440;
  }

  return {
    st: st,
    xStartPetal:xStartPetal,
    xStopPetal:xStopPetal
  }

}());

var PetalJs = (function () {

  "use strict";
  /*global $,jQuery,TweenMax,Expo,Quad,Bounce,Power3*/

  var targetID = '#p-token__gold';
  var st=0;
  var targetAreaWidth=1440;//エリア幅
  var targetAreaHeight=622;//エリア高さ
  var petalScaleBase=1;//花びら基本スケール
  var petalBackNumber=30;//背景花びら枚数
  var petalFrontNumber=20;//前景ぼかし花びら枚数
  var isPetalPlaying=false;//花びら再生中か否か

  (function ($) {
    ///$(document).ready(onTopReady);
    $(window).resize(onResize);
    $(window).scroll(onScroll);
  }(jQuery));

  function onTopReady(){
    //テスト用ボタン設定
    $("#startBtn").on("click",onStartBtnClick);
    $("#stopBtn").on("click",onStopBtnClick);
  }

  /** startボタンクリック */
  function onStartBtnClick(){
    xStartPetal();
  }

  /** stopボタンクリック */
  function onStopBtnClick(){
    xStopPetal();
  }

  /** 花びら落下を開始します */
  function xStartPetal(){

    //再生中であれば実行しない
    if(isPetalPlaying)return;
    isPetalPlaying=true;

    //エリアサイズ初期化
    onResize();

    //背景用花びら生成
    xSetPetalBack();

    //前景用ぼかし花びら生成
    xSetPetalFront();
  }

  /** 花びら落下を終了します */
  function xStopPetal(){

    //停止中であれば実行しない
    if(!isPetalPlaying)return;
    isPetalPlaying=false;

    //アニメーション停止
    for(var i = 0; i < petalBackNumber; i++){
      gsap.killTweensOf($("#petal_"+i));
    }
    for(var i = 0; i < petalFrontNumber; i++){
      gsap.killTweensOf($("#petal_blur_"+i));
    }

    // 花びらタグ撤去
    $("#petalAreaBack").empty();
    $("#petalAreaFront").empty();
  }


  /** 背景用花びらセット */
  function xSetPetalBack(){
    //背景花びら
    for(var i = 0; i < petalBackNumber; i++){
      var rnd=Math.floor(Math.random()*4)+1;
      var tag='<img id="petal_'+i+'" class="petal" src="/touken/assets/img/petal/petal'+rnd+'.png" alt="">'
      $("#petalAreaBack").append(tag);

      //花びら初期位置
      gsap.set("#petal_"+i,{
        "opacity":1,
        x:Math.random()*targetAreaWidth*1.4-targetAreaWidth*0.2,
        y:-targetAreaHeight*Math.random(),
        scale:(Math.random()*0.4+0.6)*petalScaleBase,
        "display":"block"});
      //花びら目標位置
      gsap.to("#petal_"+i,{
        duration:10+Math.random()*14,
        "opacity":1,
        x:Math.random()*targetAreaWidth*1.4-targetAreaWidth*0.2,
        y:targetAreaHeight+50,
        rotationX:600*Math.random(),
        rotationY:10000*Math.random(),
        rotationZ:6000*Math.random(),
        scale:(Math.random()*0.5+0.3)*petalScaleBase,
        delay:0,
        ease:Linear.easeNone,
        onComplete:onFallBack,
        onCompleteParams:[$("#petal_"+i)]});
    }
  }

  /** 背景用花びら落下時 */
  function onFallBack($tgt){
    //花びら初期位置
    gsap.set($tgt,{
      "opacity":1,
      x:Math.random()*targetAreaWidth*1.4-targetAreaWidth*0.2,
      y:-100,
      scale:(Math.random()*0.4+0.6)*petalScaleBase,
      "display":"block"});
    //花びら目標位置
    gsap.to($tgt,{
      duration:10+Math.random()*14,
      "opacity":1,
      x:Math.random()*targetAreaWidth*1.4-targetAreaWidth*0.2,
      y:targetAreaHeight+50,
      rotationX:600*Math.random(),
      rotationY:10000*Math.random(),
      rotationZ:6000*Math.random(),
      scale:(Math.random()*0.5+0.3)*petalScaleBase,
      delay:0,
      ease:Linear.easeNone,
      onComplete:onFallBack,
      onCompleteParams:[$tgt]});
  }

  /** 前景ぼかし用花びらセット */
  function xSetPetalFront(){
    //前景ぼかし花びら
    for(var i = 0; i < petalFrontNumber; i++){
      var rnd=Math.floor(Math.random()*4)+1;
      var tag='<img id="petal_blur_'+i+'" class="petal" src="/touken/assets/img/petal/petal'+rnd+'_blur.png" alt="">'
      $("#petalAreaFront").append(tag);
      //花びら初期位置
      gsap.set("#petal_blur_"+i,{
        "opacity":1,
        x:Math.random()*targetAreaWidth*1.4-targetAreaWidth*0.2,
        y:-targetAreaHeight*Math.random()-100,
        scale:(Math.random()*0.4+0.6)*petalScaleBase,
        "display":"block"});
      //花びら目標位置
      gsap.to("#petal_blur_"+i,{
        duration:10+Math.random()*14,
        "opacity":1,
        x:Math.random()*targetAreaWidth,
        y:targetAreaHeight+50,
        rotationX:60*Math.random(),
        rotationY:1000*Math.random(),
        rotationZ:600*Math.random(),
        scale:(Math.random()*0.5+0.3)*petalScaleBase,
        delay:0,
        ease:Linear.easeNone,
        onComplete:onFallFront,
        onCompleteParams:[$("#petal_blur_"+i)]});
    }
  }

  /** 前景ぼかし花びら落下時 */
  function onFallFront($tgt){
    //花びら初期位置
    gsap.set($tgt,{
      "opacity":1,
      x:Math.random()*targetAreaWidth*1.4-targetAreaWidth*0.2,
      y:-200,
      scale:(Math.random()*0.4+0.6)*petalScaleBase,
      "display":"block"});
    //花びら目標位置
    gsap.to($tgt,{
      duration:10+Math.random()*14,
      "opacity":1,
      x:Math.random()*targetAreaWidth*1.4-targetAreaWidth*0.2,
      y:targetAreaHeight+50,
      rotationX:60*Math.random(),
      rotationY:1000*Math.random(),
      rotationZ:600*Math.random(),
      scale:(Math.random()*0.5+0.3)*petalScaleBase,
      delay:0,
      ease:Linear.easeNone,
      onComplete:onFallFront,
      onCompleteParams:[$tgt]});
  }

  /*** スクロール ***/
  function onScroll() {

    //スクロール位置
    st = $(window).scrollTop();

    //花びら対象エリア
    var targetAreaTop=$(targetID).offset().top;

    //花びら対象エリアが表示されているときは再生 テスト
    if(st+window.innerHeight>targetAreaTop && st-targetAreaHeight<targetAreaTop){
      xStartPetal();
    }else {
      xStopPetal();
    }
  }

  /*** ステージリサイズ ***/
  function onResize() {

    // エリアサイズを取得
    targetAreaWidth = $(targetID).width();
    targetAreaHeight = $(targetID).height();

    // エリアサイズで花びらスケール調整
    petalScaleBase = targetAreaWidth/1440;
  }

  return {
    st: st,
    xStartPetal:xStartPetal,
    xStopPetal:xStopPetal
  }

}());

